import {
    Box,
    Field,
    Flex,
    FlexProps,
    Grid,
    Heading,
    Input,
    Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import ym from 'react-yandex-metrika';
import {
    Button,
    InfoDialog,
    createLeadThunk,
    useAppDispath,
} from 'shared';
import BaseError from 'utils/base-error';

type FormValues = {
    name: string
    phone: string
}

export type LeadSmallSectionProps = {
    title: string
    pdfUrl?: string
    buttonText: string
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const LeadSmallSection: React.FC<LeadSmallSectionProps> = ({
    title,
    pdfUrl,
    buttonText,
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const [title2, setTitle2] = useState('');
    const [text, setText] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useAppDispath();

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>();

    const onSubmit = handleSubmit(async (data) => {
        setIsLoading(true);
        dispatch(createLeadThunk({
            name: data.name,
            phone: data.phone,
        })).then(({ payload }) => {
            if (payload instanceof BaseError) {
                setTitle2('Ошибка при отправке');
                setText('Обновите страницу или попробуйте позже');
            } else {
                setTitle2('Заявка отправлена');
                setText('Наши специалисты свяжутся с вами в ближайшее время');
            }
            ym('reachGoal', 'corso-catering.ru/small-lead');
            setOpen(true);
        }).catch(() => {
            console.log();
        }).finally(() => {
            setIsLoading(false);
        });
    });

    return (
        <Flex
            flexDirection="column"
            gap="0.5rem"
            {...props}
        >
            <Heading
                colorScheme="variant"
                fontSize="2rem"
            >
                {title}
            </Heading>
            <form onSubmit={onSubmit}>
                <Grid
                    templateColumns={{
                        base: '1fr',
                        lg: '1fr 1fr 1fr',
                    }}
                    gap="1rem"
                    height="fit-content"
                    color="#ffffff"
                >
                    <Controller
                        name="name"
                        control={control}
                        rules={{
                            required: 'Поле не может быть пустым',
                        }}
                        render={({ field }) => (
                            <Field.Root invalid={errors.name}>
                                <Input
                                    {...field}
                                    placeholder="Ваше имя"
                                    inputMode="text"
                                />
                                <Field.ErrorText fontSize="1rem">
                                    {errors.name?.message}
                                </Field.ErrorText>
                            </Field.Root>
                        )}
                    />
                    <Controller
                        name="phone"
                        control={control}
                        rules={{
                            required: 'Поле не может быть пустым',
                        }}
                        render={({ field }) => (
                            <Field.Root invalid={errors.phone}>
                                <Input
                                    {...field}
                                    placeholder="Номер телефона"
                                    inputMode="tel"
                                    height="100%"
                                />
                                <Field.ErrorText fontSize="1rem">
                                    {errors.phone?.message}
                                </Field.ErrorText>
                            </Field.Root>
                        )}
                    />
                    <Button
                        type="submit"
                        colorScheme="accent"
                        size="lg"
                        padding="2rem"
                        loading={isLoading}
                    >
                        {buttonText}
                    </Button>
                </Grid>
            </form>
            <Grid
                templateColumns="1fr auto 1fr"
                gap="1rem"
            >
                <Box
                    margin="auto 0"
                    background="white"
                    height="1px"
                />
                <Text
                    colorScheme="variant"
                    fontSize="1.5rem"
                >
                    или
                </Text>
                <Box
                    margin="auto 0"
                    background="white"
                    height="1px"
                />
            </Grid>
            <Box width="fit-content" margin="0 auto">
                <Link to={pdfUrl || ''} target="_blank">
                    <Text
                        colorScheme="variant"
                        fontSize="1.5rem"
                        textDecoration="underline"
                        fontWeight="bold"
                        textAlign="center"
                    >
                        Скачать презентацию
                    </Text>
                </Link>
            </Box>
            <InfoDialog
                title={title2}
                open={open}
                setOpen={setOpen}
                body={
                    <Text>{text}</Text>
                }
            />
        </Flex>
    );
};
